import { formatPrismicData } from '@monofront/business/utils';
import { IMultipleProductsCarousels } from './types';
import { MultipleProductsCarouselsSlice } from '@monofront/slice-machine/prismicio-types';
import { IHateInterfaces } from '@monofront/types';

const excludeFromFormatting = [
  'collection',
  'collection_link',
  'collection_preprod',
];

export const mapMultipleProductsCarousel = ({
  prismicContent,
}: {
  prismicContent: MultipleProductsCarouselsSlice;
}): IMultipleProductsCarousels => {
  const { primary, items }: IMultipleProductsCarousels = formatPrismicData(
    prismicContent as IHateInterfaces<typeof prismicContent>,
    excludeFromFormatting,
  );

  return {
    primary,
    items,
  };
};
